/**
 * watchProviders — iter63z'''''''''''''
 *
 * Per-match box-score deep links. Only ESPN at the moment (FIFA/Fox were
 * dropped because their public per-match URLs aren't reachable without
 * internal IDs we don't have a mapping for).
 *
 * Supported templates: world_cup_api, world_cup_ko_api, world_cup
 * (legacy group+KO manual/ESPN). Other templates → returns null.
 *
 * Per-match deep-link quality:
 *   • world_cup (legacy):    Stores ESPN gameId via sync → opens the
 *                            dedicated ESPN match page (true box score).
 *   • world_cup_api / _ko_api: ESPN gameId not yet stored on these rows.
 *                              Falls back to a date-filtered fixtures URL.
 *                              Backlog: enrich materializer with ESPN
 *                              scoreboard lookup to upgrade these too.
 */

const WORLD_CUP_TEMPLATES = new Set([
    "world_cup_api",
    "world_cup_ko_api",
    "world_cup",
]);

const _yyyymmdd = (iso) => {
    if (!iso) return null;
    try {
        const d = new Date(iso);
        // iter63z bug-2026-06b — Use the USER'S LOCAL date components,
        // not UTC. A 7 PM PT game with scheduled_at "2026-06-18T02:00:00Z"
        // shows under "Wednesday Jun 17" in the user's Schedule view
        // (local-date grouping), so the ESPN deep-link must use the same
        // local-date YYYYMMDD — otherwise it lands on ESPN's June 18
        // fixtures page which has different games. Cross-timezone-safe.
        const yr = d.getFullYear();
        const mo = String(d.getMonth() + 1).padStart(2, "0");
        const dy = String(d.getDate()).padStart(2, "0");
        return `${yr}${mo}${dy}`;
    } catch { return null; }
};

function _espnUrl(entry) {
    const espnId = entry?.espn_id;
    if (espnId) return `https://www.espn.com/soccer/match/_/gameId/${espnId}`;
    const dateCompact = _yyyymmdd(entry?.scheduled_at);
    if (dateCompact) {
        return `https://www.espn.com/soccer/fixtures/_/league/fifa.world/date/${dateCompact}`;
    }
    return "https://www.espn.com/soccer/fixtures/_/league/fifa.world";
}

function _espnSub(entry) {
    if (entry?.espn_id) return "Box score · stats, lineups, commentary";
    return "Find this match in ESPN's date-filtered fixtures list";
}

/**
 * Public API: providers for a given (template, entry). Returns an array
 * of provider buttons (currently always length 1 — ESPN only). null if
 * the template isn't supported.
 */
export function getWatchProviders(template, entry) {
    if (!template || !WORLD_CUP_TEMPLATES.has(template)) return null;
    const e = entry || {};
    return [
        {
            key: "espn",
            label: "ESPN Game Score",
            url: _espnUrl(e),
            sub: _espnSub(e),
        },
    ];
}

/**
 * Public API: cheap check used to decide whether to render the icon
 * in the first place.
 */
export function templateHasWatchProviders(template) {
    return !!template && WORLD_CUP_TEMPLATES.has(template);
}
